import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import { INLINES } from '@contentful/rich-text-types';

const rawToReact = (raw: string, options?: any) => {
    try {
        const jsonContent = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!jsonContent.content) return "";
        return documentToReactComponents(jsonContent, options);
    } catch (error) {
        return "";
    }
};

export default rawToReact;

export const targetBlankOption = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const url = node.data.uri;
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        );
      },
    },
};
